import { ReactNode } from 'react';
import { cx } from '@emotion/css';

import styles from './ProjectsPageLayout.module.scss';
import { createFadeInAnimation } from '@tcc-online/common-components';
import BasePageLayout from '../../../common/components/BasePageLayout/BasePageLayout';

type ProjectsPageLayoutProps = {
    children?: ReactNode;
};

export default function ProjectsPageLayout(props: ProjectsPageLayoutProps) {
    const { children } = props;
    const fadeIn = createFadeInAnimation();

    return (
        <BasePageLayout classNames={{ layout: cx(styles.layout, fadeIn) }}>
            {children}
        </BasePageLayout>
    );
}
